"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";
import Header from "@/components/Header";
import FooterNew from "@/components/FooterNew";

export default function LayoutShell({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const hideChrome =
    pathname === "/partner-onboarding-form" || pathname === "/report-issue";

  if (hideChrome) {
    return <main>{children}</main>;
  }

  return (
    <>
      <Header />
      <main>{children}</main>
      <FooterNew />
    </>
  );
}
